'use client';
import { ApiClientsError } from '#pplx/frontend/api-clients/core/errors.js';
import { getQueryTimeoutMs } from '#pplx/frontend/api-clients/core/utils.js';
import { onboardingClient } from '#pplx_generated/typespec/rest/onboarding/client.js';
const ENDPOINT = '/rest/onboarding/computer-v2';
const ANSWER_ENDPOINT = '/rest/onboarding/computer-v2/answer';
const BUSINESS_OWNER_SEGMENT = 'business-owner';
export function parseComputerOnboardingAcquisitionSegment(segment) {
    if (segment === BUSINESS_OWNER_SEGMENT || segment === 'student') {
        return segment;
    }
    return undefined;
}
export async function getComputerOnboardingV2({ reason, subscriptionTier, subSegment, segment, }) {
    const { data, error, response } = await onboardingClient.GET(ENDPOINT, reason, {
        params: {
            query: {
                subscription_tier: subscriptionTier,
                ...(subSegment !== undefined && { sub_segment: subSegment }),
                ...(segment !== undefined && { segment }),
            },
        },
        timeoutMs: getQueryTimeoutMs(),
    });
    if (error || !data) {
        throw new ApiClientsError('API_CLIENTS_ERROR', {
            message: 'Failed to fetch computer onboarding v2',
            cause: error,
            status: response.status ?? 0,
        });
    }
    return data;
}
export async function saveComputerOnboardingV2Answer({ reason, stepId, step, subscriptionTier, customOccupation, }) {
    const body = {
        step_id: stepId,
        step,
        ...(customOccupation !== undefined && { custom_occupation: customOccupation }),
    };
    const { data, error, response } = await onboardingClient.POST(ANSWER_ENDPOINT, reason, {
        ...(subscriptionTier !== undefined && {
            params: { query: { subscription_tier: subscriptionTier } },
        }),
        body,
        timeoutMs: getQueryTimeoutMs(),
    });
    if (error || !data?.success) {
        throw new ApiClientsError('API_CLIENTS_ERROR', {
            message: 'Failed to save computer onboarding v2',
            cause: error,
            status: response.status ?? 0,
        });
    }
    return data;
}
//# sourceMappingURL=computerOnboardingV2Api.js.map